import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  TableSettingsBody,
  TableSettingsResponse
} from '@/app/common/api/types/tableSettingApiTypes';

const tableApi = createApi({
  reducerPath: 'tableApi',
  baseQuery: (...args) => customFetchBase(getBaseApiPath(), ...args),
  endpoints: build => ({
    getTableSettings: build.query<TableSettingsResponse, TableSettingsBody>({
      query: body => ({
        url: `plus/v1/table_settings/get`,
        method: 'POST',
        body
      })
    }),
    postTableSettings: build.mutation<TableSettingsResponse, TableSettingsBody>(
      {
        query: body => ({
          url: `/plus/v1/table_settings/insert_or_update`,
          method: 'POST',
          body
        })
      }
    )
  })
});

export const { useGetTableSettingsQuery, usePostTableSettingsMutation } =
  tableApi;

export default tableApi;
